module.exports = " <div class=content> <div id=listId> <div class=content-block-title>知乎日报</div> <div class=\"list-block media-list inset\"> <ul> <li v-for=\"item in items\"> <a @click=goif(item) class=\"item-link item-content\"> <div class=item-inner> <div class=item-title>{{item.name}}</div> </div> </a> </li> </ul> </div> </div> <iframe id=ifId :src=\"\"></iframe> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.4/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab/Zhihu.vue
 ** module id = 21
 ** module chunks = 1
 **/